import { CalendarDays, Users, IndianRupee } from "lucide-react";

export default function BookingSummaryChips({
    variant = "light",
    travelDates,
    adults,
    children,
    infants,
    quoteTotal,
    quoteDeposit,
    quoteCurrency = "INR",
    quoteTotalConverted = null,
    quoteDepositConverted = null,
}) {
    const CURRENCY_SYMBOLS = { USD: "$", EUR: "€", GBP: "£" };
    const sym = CURRENCY_SYMBOLS[quoteCurrency] || `${quoteCurrency} `;
    const chipBase =
        variant === "dark"
            ? "inline-flex items-center gap-2 px-3 py-2 border border-primary-foreground/25 text-primary-foreground/90 text-xs"
            : "inline-flex items-center gap-2 px-3 py-2 border border-border bg-secondary text-foreground text-xs";

    return (
        <div className="flex flex-wrap items-center gap-2" data-testid="enquiry-booking-summary">
            <span className={chipBase}>
                <CalendarDays size={14} strokeWidth={1.5} />
                <span data-testid="enquiry-booking-summary-dates">{travelDates}</span>
            </span>
            <span className={chipBase}>
                <Users size={14} strokeWidth={1.5} />
                <span data-testid="enquiry-booking-summary-travelers">
                    {adults || 0} adult{(adults || 0) !== 1 ? "s" : ""}
                    {children ? ` · ${children} child${children !== 1 ? "ren" : ""}` : ""}
                    {infants ? ` · ${infants} infant${infants !== 1 ? "s" : ""}` : ""}
                </span>
            </span>
            {quoteTotal ? (
                <span className={chipBase} data-testid="enquiry-booking-summary-quote">
                    <IndianRupee size={14} strokeWidth={1.5} />
                    <span>
                        Est. ₹{(quoteTotal || 0).toLocaleString("en-IN")}
                        {quoteDeposit ? ` · deposit ₹${quoteDeposit.toLocaleString("en-IN")}` : ""}
                        {quoteCurrency !== "INR" && quoteTotalConverted
                            ? ` (≈ ${sym}${Math.round(quoteTotalConverted).toLocaleString("en-US")}${quoteDepositConverted ? ` · ${sym}${Math.round(quoteDepositConverted).toLocaleString("en-US")} deposit` : ""})`
                            : ""}
                    </span>
                </span>
            ) : null}
        </div>
    );
}
